import clsx from 'clsx';
import React from 'react';

export function Header1(props: React.HTMLAttributes<HTMLHeadingElement>) {
	return <h1 className={clsx('text-3xl font-semibold text-gray-900', props.className)} {...props} />;
}
